<template>
  <div class="flex p-l-15 col-stretch">
    <img :src="skuImage" width="70px" />
    <div class="goods-name flex-col row-between">
      <div class="name">{{ info.productName }}</div>
      <div class="sku-info-con m-t-8">
        <span
          v-if="info.productSkuSpec"
          class="sku-name"
          :title="productSkuSpec"
        >
          {{ productSkuSpec }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { isString } from 'lodash'

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  computed: {
    skuImage() {
      return process.env.VUE_APP_OSS_URL + '/' + this.info.productSkuImage
    },

    productSkuSpec() {
      if (isString(this.info.productSkuSpec)) {
        return this.info.productSkuSpec
      }
      const productSkuSpec = this.info.productSkuSpec || {}
      return Object.keys(productSkuSpec)
        .map(key => `${key}:${productSkuSpec[key]}`)
        .join('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-img {
  width: 70px;
  height: 70px;
}

.goods-name {
  word-break: break-word;
  flex: 1;
  margin: 0 15px;
  max-width: 300px;

  .name {
    max-height: 36px;
    line-height: 18px;
    cursor: pointer;
    text-align: left;
    @include row-ellipsis(2);

    &:hover {
      color: $primary-color;
    }
  }

  .sku {
    color: $third-text-color;
  }

  .sku-info-con {
    display: flex;
    align-items: center;

    .sku-name {
      max-width: 60%;
      margin-right: 10px;
      color: $third-text-color;
      @include row-ellipsis(1);
    }
  }
}
</style>
